import React from 'react';
import Button, { Color as ButtonColor } from 'lib/Button';
import closeSvg from 'assets/icons/close.svg';
import personSvg from 'assets/icons/person.svg';
import CopyToClipboardButton from 'components/common/CopyToClipboardButton';
import { CampaignPlanSingleFurnitureCardProps } from './CampaignPlanSingleFurnitureCard.types';
import CampaignPlanSingleFurnitureCardItem from './CampaignPlanSingleFurnitureCardItem';

const CampaignPlanSingleFurnitureCard: React.FC<CampaignPlanSingleFurnitureCardProps> = ({
  furniture,
  cardPosition,
  onClose,
  openStreetView,
}) => {
  const { furnitureCode, address1, address2, longitude, latitude, assetsInformation } = furniture;
  const { position } = cardPosition;

  return (
    <div
      data-test-id={`campaign-plan-cluster-card-${furnitureCode}`}
      className="absolute rounded-xl shadow-lg bg-white w-[330px] overscroll-contain flex flex-col max-h-[80%] min-h-0"
      style={{
        left: `${position[0]}px`,
        top: `${position[1]}px`,
        transform: 'translate(-113%, -40%)',
      }}
    >
      <div className="w-full flex items-center rounded-t-xl justify-between py-3 px-4 bg-neutral-200 group">
        <span className="w-2/3 font-bold body-lg whitespace-nowrap overflow-hidden truncate">{furnitureCode}</span>
        <div className="flex items-center space-x-4">
          <CopyToClipboardButton
            dataTestId="campaign-plan-copy-furniture-id"
            textToCopy={furnitureCode}
            color={ButtonColor.GREY}
            svgClassnames="w-4 h-4 text-neutral-900"
            buttonClassnames="opacity-0 group-hover:opacity-100"
          />
          <Button
            dataTestId="campaign-plan-close-furniture-card"
            svg={closeSvg}
            color={ButtonColor.GREY}
            onClick={onClose}
          />
        </div>
      </div>

      <div className="flex px-4 pt-2 mt-2">
        <div className="flex-1 group">
          <div className="w-4/5 body-base text-gray-800">{address1}</div>
          <div className="w-full flex items-center gap-2 body-base text-gray-800 mb-3">
            <span className="w-2/3">{address2}</span>
            <CopyToClipboardButton
              dataTestId="campaign-plan-copy-furniture-address"
              textToCopy={`${address1}, ${address2}`}
              color={ButtonColor.TERTIARY}
              svgClassnames="w-2 h-2 text-neutral-900"
              buttonClassnames="opacity-0 group-hover:opacity-100"
              isDisabled={false}
            />
          </div>
        </div>
        <Button
          dataTestId="campaign-plan-open-street-view"
          svg={personSvg}
          color={ButtonColor.GREY}
          classNames="w-8 h-8"
          svgClassnames="w-8 h-8"
          onClick={() => openStreetView({ lat: latitude, lng: longitude })}
        />
      </div>

      <div className="space-y-3 flex flex-col overflow-y-auto px-4 pb-3 mb-3 min-h-0">
        {assetsInformation.map((assetItem) => (
          <CampaignPlanSingleFurnitureCardItem
            key={assetItem.frameId}
            frameId={assetItem.frameId}
            isDigital={assetItem.isDigital}
            frameSize={assetItem.frameSize}
            impressions={assetItem.impressions}
            isImpressions={assetItem.isImpressions ?? false}
            sot={assetItem.sot}
          />
        ))}
      </div>
    </div>
  );
};

export default CampaignPlanSingleFurnitureCard;
